import React, { Component } from "react"
import RCT2ScenarioButton from "../RCT2ScenarioButton/RCT2ScenarioButton"
import RCT2ScenarioVersion from "../RCT2ScenarioVersion/RCT2ScenarioVersion"

class RCT2Scenario extends Component {
// function RCT2Scenario () {
  
  state = { id: "" }
  setID = (getID) => {
    this.setState({id: getID})
  }

  clearScenario = () => { 
    this.setState({id: ""})
  }
  
  render () {
    return (
      <>
        <p>Rollercoaster Tycoon 2 Scenarios:</p>
        <ul className="RCT2-Scenario-List">
          <RCT2ScenarioButton readID={this.setID} id="californias-great-america" name="California's Great America" />
          <RCT2ScenarioButton readID={this.setID} id="canadas-wonderland" name="Canada's Wonderland" />
          <RCT2ScenarioButton readID={this.setID} id="carowinds" name="Carowinds" />
          <RCT2ScenarioButton readID={this.setID} id="dorney-park" name="Dorney Park" />
          <RCT2ScenarioButton readID={this.setID} id="kings-dominion" name="Kings Dominion" />
          <RCT2ScenarioButton readID={this.setID} id="kings-island" name="Kings Island" />
          <RCT2ScenarioButton readID={this.setID} id="knotts-berry-farm" name="Knott's Berry Farm" />
          <RCT2ScenarioButton readID={this.setID} id="michigans-adventure" name="Michigan's Adventure" />
          <RCT2ScenarioButton readID={this.setID} id="valleyfair" name="Valleyfair" />
          <RCT2ScenarioButton readID={this.setID} id="worlds-of-fun" name="Worlds of Fun" />
        </ul>
        
        <div id="scenario">
          {this.state.id !== "" &&
          <>
            <div className="close-download">
              <button onClick={this.clearScenario}></button>
            </div>
          </>
          }
          {this.state.id === "californias-great-america" &&
          <>
            <RCT2ScenarioVersion id="californias-great-america" name="California's Great America" year="2022" buildYourOwn="true" note={<>*This was made specifically for OpenRCT2. It may or may not work with the base RollerCoaster Tycoon 2 game.<br />The single rail coaster will only work in OpenRCT2; trains for it were downloaded from here: <a href="https://www.nedesigns.com/topic/34573/spaceks-custom-rides/">https://www.nedesigns.com/topic/34573/spaceks-custom-rides/</a></>} />
          </>
          }
          {this.state.id === "canadas-wonderland" &&
          <>
            <RCT2ScenarioVersion id="canadas-wonderland" name="Canada's Wonderland" year="2024" buildYourOwn="true" note="*This was made specifically for OpenRCT2. It may or may not work with the base RollerCoaster Tycoon 2 game." />
          </>
          }
          {this.state.id === "carowinds" &&
          <>
            <RCT2ScenarioVersion id="carowinds" name="Carowinds" year="2023" buildYourOwn="true" note="*This was made specifically for OpenRCT2. It may or may not work with the base RollerCoaster Tycoon 2 game." />
          </>
          }
          {this.state.id === "dorney-park" &&
          <>
            <RCT2ScenarioVersion id="dorney-park" name="Dorney Park" year="2024" buildYourOwn="true" note="*This was made specifically for OpenRCT2. It may or may not work with the base RollerCoaster Tycoon 2 game." />
            <RCT2ScenarioVersion id="dorney-park" name="Dorney Park" year="2022" buildYourOwn="true" note="*This was made specifically for OpenRCT2. It may or may not work with the base RollerCoaster Tycoon 2 game." />
          </>
          }
          {this.state.id === "kings-dominion" &&
          <>
            <RCT2ScenarioVersion id="kings-dominion" name="Kings Dominion" year="2022" buildYourOwn="true" note="*This was made specifically for OpenRCT2. It may or may not work with the base RollerCoaster Tycoon 2 game." />
          </>
          }
          {this.state.id === "kings-island" &&
          <>
            <RCT2ScenarioVersion id="kings-island" name="Kings Island" year="2023" buildYourOwn="true" note="*This was made specifically for OpenRCT2. It may or may not work with the base RollerCoaster Tycoon 2 game." />
          </>
          }
          {this.state.id === "knotts-berry-farm" &&
          <>
            <RCT2ScenarioVersion id="knotts-berry-farm" name="Knott's Berry Farm" year="2022" buildYourOwn="true" note="*This was made specifically for OpenRCT2. It may or may not work with the base RollerCoaster Tycoon 2 game." />
          </>
          }
          {this.state.id === "michigans-adventure" &&
          <>
            <RCT2ScenarioVersion id="michigans-adventure" name="Michigan's Adventure" year="2022" buildYourOwn="true" note="*This was made specifically for OpenRCT2. It may or may not work with the base RollerCoaster Tycoon 2 game." />
          </>
          }
          {this.state.id === "valleyfair" &&
          <>
            <RCT2ScenarioVersion id="valleyfair" name="Valleyfair" year="2021" buildYourOwn="true" note="*This was made specifically for OpenRCT2. It may or may not work with the base RollerCoaster Tycoon 2 game." />
            <RCT2ScenarioVersion id="valleyfair" name="Valleyfair" year="2015" buildYourOwn="false" note="*Requires Time Twister Expansion Pack" />
            <RCT2ScenarioVersion id="valleyfair" name="Valleyfair" year="2008" buildYourOwn="false" note="" />
          </>
          }
          {this.state.id === "worlds-of-fun" &&
          <>
            <RCT2ScenarioVersion id="worlds-of-fun" name="Worlds of Fun" year="2022" buildYourOwn="true" note="*This was made specifically for OpenRCT2. It may or may not work with the base RollerCoaster Tycoon 2 game." />
          </>
          }
        </div>
      </>
    )
  }
}

export default RCT2Scenario